import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import * as yup from 'yup';
import { i18n as I18n } from '../../../utils/i18n';

// Components
import CheckBoxList from '../../fields/checkBoxList';
import InputError from '../../fields/inputError';
import ServiceDetailsContainer from '../serviceDetailsContainer';

// Hooks
import useValidation from '../../../hooks/useValidation';
import useClientServices from '../../../hooks/useClientServices';

const schema = yup.object().shape({
  existingClientServices: yup.array().of(yup.string()),
});

const ExistingServiceDetails = ({
  fields,
  submissionErrors,
  handleFieldChange,
  handleSubmitCallback,
  handleGoBack,
  previousStep,
}) => {
  const { errors, validate, isValid } = useValidation(fields, schema);
  const { data: clientServices = [] } = useClientServices(
    fields.companyName.value
  );

  // Validate only when services change.
  const hasMounted = useRef(false);
  useEffect(() => {
    if (hasMounted.current) {
      validate();
    } else {
      hasMounted.current = true;
    }
  }, [fields.existingClientServices, validate]);

  const handleChange = event => {
    handleFieldChange(event);
  };

  const handleSubmit = event => {
    event.preventDefault();

    validate();
    if (isValid()) {
      handleSubmitCallback();
    }

    return false;
  };

  return (
    <ServiceDetailsContainer
      handleSubmit={handleSubmit}
      submissionErrors={submissionErrors}
      isValid={isValid()}
      handleGoBack={handleGoBack}
      previousStep={previousStep}
    >
      <div className="service-container service-container--existing">
        <h4>
          {I18n.t('registration.service_details.container_title_existing')}
        </h4>
        <CheckBoxList
          name="existingClientServices[]"
          options={clientServices.map(option => ({
            name: option.name,
            value: option.id,
            checked: fields.existingClientServices.includes(option.id),
          }))}
          id="existingClientServices"
          onChange={handleChange}
        />
        {errors.existingClientServices && (
          <InputError errorMsg={errors.existingClientServices} />
        )}

        <p>
          {I18n.t('registration.service_details.existing_company_instructions')}
        </p>
      </div>
    </ServiceDetailsContainer>
  );
};

ExistingServiceDetails.propTypes = {
  fields: PropTypes.object.isRequired,
  submissionErrors: PropTypes.arrayOf(PropTypes.string),
  handleFieldChange: PropTypes.func.isRequired,
  handleSubmitCallback: PropTypes.func.isRequired,
  handleGoBack: PropTypes.func,
  previousStep: PropTypes.number,
};

ExistingServiceDetails.defaultProps = {
  previousStep: 2,
};
export default ExistingServiceDetails;
